const ID_MARKET_PAYMENT_1 = '000146f2cab539426b1bf5aa4b427c5a';
const ID_MARKET_PAYMENT_2 = '000241affb6e69b14643f73ad0b77180';
const ID_MARKET_PAYMENT_3 = '0003c1ab8b7d823609dbcc93e230d3e7';
const ID_MARKET_PAYMENT_4 = '00044803392ee3f60da93c78401ca2e9';
const ID_MARKET_PAYMENT_5 = '0005b796a6cec7f9f9d4955341403cdd';
const ID_MARKET_PAYMENT_6 = '0006d22317293bdc3515caea1fd22201';
const ID_MARKET_PAYMENT_7 = '00078500b2bd4217d0241e16e6e3a00a';

export const DEFAULT_MARKET_PAYMENTS = {
  [ID_MARKET_PAYMENT_1]: {
    name: 'Payment 1',
  },
  [ID_MARKET_PAYMENT_2]: {
    name: 'Payment 2',
  },
  [ID_MARKET_PAYMENT_3]: {
    name: 'Payment 3',
  },
  [ID_MARKET_PAYMENT_4]: {
    name: 'Payment 4',
  },
  [ID_MARKET_PAYMENT_5]: {
    name: 'Payment 5',
  },
  [ID_MARKET_PAYMENT_6]: {
    name: 'Payment 6',
  },
  [ID_MARKET_PAYMENT_7]: {
    name: 'Payment 7',
  },
};

export const ID_MARKET_NOTE = '0001b121810e2b57bda5b79175679e59';

export const DEFAULT_MARKET_NOTE_CATEGORIES = {
  [ID_MARKET_NOTE]: {
    name: 'Note',
  },
};
